import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, AxiosInstance, AxiosResponse } from "axios";

import * as requestUrl from "../../constants/request";
import { CombinedConfiguration } from "./configuration";
import { GenericActionError } from "store/common";

interface FetchClientConfigProps {
  request: AxiosInstance;
  data: { key: string };
}

export const fetchConfig = createAsyncThunk<
  CombinedConfiguration,
  FetchClientConfigProps,
  {
    rejectValue: GenericActionError;
  }
>("config/fetchConfig", async ({ request, data }, thunkApi) => {
  let configResponse: AxiosResponse<any, any> | null = null;

  try {
    configResponse = await request(requestUrl.FT_PAYMENT_CENTER_CONFIG);
  } catch (e) {
    const axoisError = e as AxiosError<any, any>;
    if (!!axoisError.response && axoisError.response.status === 404) {
      return thunkApi.rejectWithValue({
        status: axoisError.response.status,
        statusMessage: axoisError.response.statusText,
      });
    } else {
      return thunkApi.rejectWithValue({});
    }
  }

  if (!!configResponse) {
    if (configResponse.data.idPId) {
      localStorage.setItem(data.key, configResponse.data.idPId);
      localStorage.setItem("lastSavedKey", data.key);
    }

    return configResponse.data;
  } else {
    return thunkApi.rejectWithValue({});
  }
});

export type FetchConfig = typeof fetchConfig;
